import { cropToCanvas } from 'react-image-crop';
function getCroppedFileName(originalName) {
    const lastDotIndex = originalName.lastIndexOf('.');
    if (lastDotIndex <= 0) {
        return `${originalName || 'image'}_cropped`;
    }
    return `${originalName.slice(0, lastDotIndex)}_cropped${originalName.slice(lastDotIndex)}`;
}
export default async function getCroppedImageFile(image, crop, originalFile) {
    if (!crop.width || !crop.height) {
        throw new Error('Invalid crop dimensions');
    }
    const canvas = document.createElement('canvas');
    await cropToCanvas(image, canvas, crop);
    const mimeType = originalFile.type && originalFile.type.startsWith('image/')
        ? originalFile.type
        : 'image/jpeg';
    const blob = await new Promise(resolve => {
        canvas.toBlob(resolve, mimeType, 0.92);
    });
    if (!blob) {
        throw new Error('Failed to create cropped image');
    }
    return new File([blob], getCroppedFileName(originalFile.name), {
        type: blob.type || mimeType,
        lastModified: Date.now(),
    });
}
